__webpack_require__.p = "https://cart.qa.core-artifacts.com/static/";